<template>
  <q-dialog
    ref="dialog"
    :maximized="$q.platform.is.mobile"
    @hide="onDialogHide"
  >
    <q-card class="q-dialog-plugin session-activities-dialog">
      <q-card-section class="row">
        <div
          class="text-h6 ellipsis col"
        >
          {{ title }}
        </div>
        <div class="row items-center q-col-gutter-sm">
          <div>
            <q-btn
              v-close-popup
              flat
              round
              dense
              icon="close"
              class="col-auto"
            />
          </div>
        </div>
      </q-card-section>
      <q-card-section class="row">
        <banner
          v-if="message"
          :type="messageType"
          :message="message"
        />
        <session-activities-table
          use-fixed-session-activities
          :fixed-session-activities="sessionActivities"
          :default-columns="['status', 'client','userName','startTimestamp', 'endTimestamp', 'sessionName']"
          selection="none"
          flat
          disable-views
          hide-bulk-actions
          hide-pagination
          class="full-width"
        />
      </q-card-section>
      <q-card-actions class="row">
        <q-space />
        <q-btn
          color="primary"
          :label="$t('common.buttonClose')"
          flat
          @click="onOKClick"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import SessionActivitiesTable from 'components/Sessions/SessionActivitiesTable';
import Banner from 'components/UI/Banner';

export default {
  name: 'ViewSessionActivitiesDialog',

  components: { Banner, SessionActivitiesTable },

  props: {

    sessionActivities: {
      type: Array,
      required: true,
    },

    title: {
      type: String,
      default: '',
    },

    message: {
      type: String,
      default: '',
    },

    messageType: {
      type: String,
      default: 'error',
      validator: (value) => ['info', 'success', 'warning', 'error'].includes(value),
    },

  },

  emits: ['hide', 'ok'],

  data() {
    return {
    };
  },

  methods: {

    // following method is REQUIRED
    // (don't change its name --> "show")
    show() {
      this.$refs.dialog.show();
    },

    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide() {
      if (this.$refs.dialog) {
        this.$refs.dialog.hide();
      }
    },

    onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit('hide');
    },

    async onOKClick() {
      // on OK, it is REQUIRED to
      // emit "ok" event (with optional payload)
      // before hiding the QDialog
      this.$emit('ok');
      // or with payload: this.$emit('ok', { ... })

      // then hiding dialog
      this.hide();
    },

    onCancelClick() {
      // we just need to hide dialog
      this.hide();
    },

  },
};
</script>
  <style scoped>
  .session-activities-dialog {
    min-width:80vw;
  }
  </style>
